var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessIcon = function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#success-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.131 0c11.13 0 17.573 9.325 17.573 20.283 0 10.96-9.023 19.843-20.154 19.843C8.42 40.126.002 27.556.002 16.597S11 0 22.132 0Z",
    fill: "#2F8973"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.381 13.04c.8.746.831 1.986.07 2.769l-11.43 11.75a2.02 2.02 0 0 1-1.448.608 2.02 2.02 0 0 1-1.448-.608l-4.571-4.7a1.93 1.93 0 0 1 .069-2.769 2.03 2.03 0 0 1 2.827.068l3.123 3.21 9.98-10.26a2.03 2.03 0 0 1 2.828-.068Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "success-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgSuccessIcon;